export default __webpack_public_path__ + "static/media/VIP_brown.e117747c.png";